import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime"; // Formik

import { useFormikContext } from 'formik'; // Elements

import Label from '../elements/Label';
import Error from '../elements/Error'; // Third Party

import Select from 'react-select';
var inputTypes = {
  name: 'text'
};

var NameField = function NameField(_ref) {
  var _ref$formik = _ref.formik,
      formik = _ref$formik === void 0 ? {} : _ref$formik,
      _ref$hasError = _ref.hasError,
      hasError = _ref$hasError === void 0 ? false : _ref$hasError,
      fieldId = _ref.fieldId,
      data = _ref.data;

  var _useFormikContext = useFormikContext(),
      handleChange = _useFormikContext.handleChange,
      handleBlur = _useFormikContext.handleBlur,
      values = _useFormikContext.values;

  var type = data.type.toLowerCase();

  if (data.conditionalLogic) {
    // Whether or not to show the field
    if (data.conditionalLogic.actionType === 'SHOW') {
      var show = true;
      data.conditionalLogic.rules.forEach(function (rule) {
        if (rule.operator === 'IS') {
          if (values["input_".concat(rule.fieldId)] !== rule.value) {
            show = false;
          }
        }

        if (rule.operator === 'IS_NOT') {
          if (values["input_".concat(rule.fieldId)] === rule.value) {
            show = false;
          }
        }
      });

      if (!show) {
        return null;
      }
    }
  }

  return _jsx("div", {
    className: "form-duuf-group-".concat(type, " ").concat(data.cssClass ? "".concat(data.cssClass) : 'flex gap-3'),
    children: data.inputs.map(function (input, index) {
      if (input.isHidden) return null;

      if (input.choices !== null) {
        input.choices.forEach(function (choice) {
          choice['label'] = choice['text'];
        });
        return _jsxs("div", {
          className: "form-duuf-group form-duuf-group-".concat(type, "-").concat(input.key),
          children: [_jsx(Label, {
            fieldId: fieldId,
            data: input
          }), _jsx(Error, {
            fieldId: fieldId,
            data: data,
            hasError: hasError,
            formik: formik
          }), _jsx(Select, {
            onChange: function onChange(event) {
              handleChange({
                target: {
                  name: "input_".concat(input.id.toString().replace('.', '_')),
                  value: event === null || event === void 0 ? void 0 : event.value
                }
              });
            },
            placeholder: input.placeholder,
            options: input.choices,
            value: input.choices.find(function (_ref2) {
              var value = _ref2.value;
              return value === values["input_".concat(input.id.toString().replace('.', '_'))];
            }),
            classNamePrefix: "form-duuf-select"
          })]
        }, index);
      }

      return _jsxs("div", {
        className: "form-duuf-group form-duuf-group-".concat(type, "-").concat(input.key),
        children: [_jsx(Label, {
          fieldId: "input_".concat(input.id.toString().replace('.', '_')),
          data: input
        }), _jsx(Error, {
          fieldId: fieldId,
          data: data,
          hasError: hasError,
          formik: formik
        }), _jsx("input", {
          className: "form-duuf-input form-duuf-input-".concat(type),
          type: inputTypes[type] || type,
          id: "input_".concat(input.id.toString().replace('.', '_')),
          name: "input_".concat(input.id.toString().replace('.', '_')),
          placeholder: input.placeholder,
          onBlur: handleBlur,
          onChange: handleChange,
          value: values["input_".concat(input.id.toString().replace('.', '_'))],
          maxLength: data.maxLength === 0 ? undefined : data.maxLength
        })]
      }, index);
    })
  });
};

export default NameField;